<template>
  <div>
    <v-row v-if="!showFileUpload">
      <v-col>
        <EsButtonExpand label="Add Attachments" icon="mdi-plus-circle-outline" @click="showFileUpload = true" />
      </v-col>
    </v-row>
    <div v-if="showFileUpload">
      <v-row>
        <v-col cols="12">
          <EsSelect
            v-if="!hideAttachmentTypeDropdown"
            :disabled="isSaving || attachmentTypes.length === 1"
            label="Type of attachments to upload"
            required
            :items="attachmentTypes"
            v-model="attachmentType" />
          <v-file-input
            outlined
            multiple
            v-model="filesToUpload"
            chips
            ref="fileInput"
            accept=".png,.jpg,.jpeg,.gif,.txt,.pdf"
            prepend-inner-icon="mdi-attachment mdi-rotate-270"
            @click:prepend-inner="$refs.fileInput.$el.querySelector('input').click()"
            :prepend-icon="null"></v-file-input>

          <div
            v-if="showQuoteMetadata"
          >
            <EsTextField
              label="Total Quote Amount"
              v-model="totalQuoteAmount"
              type="number"
              step="0.01"
            />
            <EsAutocomplete
              label="Vendor"
              :items="vendors"
              v-model="quoteVendorId"
              itemValue="id"
              itemText="name"
              clearable
              hide-details 
            />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="4">
          <EsButtonCancel block
            :disabled="isSaving"
            @click="cancel()"/>
          </v-col>
        <v-col cols="4">
          <EsButtonSave block label="Upload"
            :loading="isSaving"
            :disabled="disableUpload"
            @click="prepareForUpload()"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
<script>
import { EsButtonExpand, EsSelect, EsButtonCancel, EsButtonSave } from "@86-repairs/design-system";

export default {
  name: 'EsAttachmentUpload',
  components: {
    EsButtonExpand,
    EsSelect,
    EsButtonCancel,
    EsButtonSave,
  },
  props: {
    hideAttachmentTypeDropdown: {
      type: Boolean,
      default: false,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    attachmentTypes: {
      type: Array,
    },
    enableMetadataEditing: {
      type: Boolean,
      default: false,
    },
    vendors: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    showFileUpload: false,
    attachmentType: null,
    filesToUpload: null,
    isSaving: false,
    totalQuoteAmount: null,
    quoteVendorId: null,
  }),
  computed: {
    disableUpload() {
      return !this.attachmentType || !this.filesToUpload;
    },
    showQuoteMetadata() {
      return this.enableMetadataEditing && this.attachmentType === 'Quote' && this.filesToUpload?.length === 1;
    },
  },
  watch: {
    isSaving(value) {
      if (value === false) {
        this.attachmentType = null;
        this.filesToUpload = null;
        this.showFileUpload = false;
        this.totalQuoteAmount = null;
        this.quoteVendorId = null;
      }
    },
    showFileUpload() {
      if (this.attachmentTypes.length === 1) {
        this.attachmentType = this.attachmentTypes[0];
      }
    },
    hideButton(value) {
      if (value) {
        this.showFileUpload = true;
      }
    }
  },
  mounted() {
    if (this.hideButton) {
      this.showFileUpload = true;
    }
  },
  methods: {
    cancel() {
      if (this.hideButton) {
        this.$emit('cancel');
      } else {
        this.showFileUpload = false;
      }
    },
    prepareForUpload() {
      if (!this.filesToUpload) {
        return;
      }
      this.isSaving = true;
      this.$emit('uploadButtonClicked', {
        payload: { 
          filesToUpload: this.filesToUpload, 
          attachmentType: this.attachmentType, 
          metadata: this.enableMetadataEditing ? { 
            totalCost: this.totalQuoteAmount, 
            vendorId: this.quoteVendorId
          } : undefined
        },
        done: () => this.doneSaving(),
      });
    },
    doneSaving() {
      this.isSaving = false;
      this.showFileUpload = false;
      this.filesToUpload = null;
      this.attachmentType = null;
      this.totalQuoteAmount = null;
      this.quoteVendorId = null;
    },
  },
};
</script>
  